module.exports = __webpack_public_path__ + "static/media/station_control_rooms.9d423541.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameSpacePort/station_control_rooms.png
// module id = 2484
// module chunks = 0